import { EnvironmentProviders, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppConfig } from '@common/tokens/app-configs.constant';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication
} from '@azure/msal-browser';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalService
} from '@azure/msal-angular';

export const msalConfigProviders: (Provider | EnvironmentProviders)[] = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory,
    deps: [AppConfig]
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory,
    deps: [AppConfig]
  },
  {
    provide: MSAL_INTERCEPTOR_CONFIG,
    useFactory: MSALInterceptorConfigFactory,
    deps: [AppConfig]
  },
  MsalService,
  MsalGuard,
  MsalBroadcastService
];

function MSALInstanceFactory(config: AppConfigModel): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: config.msalConfig.auth.clientId,
      authority: `${config.msalConfig.auth.authorityUri}/${config.msalConfig.auth.tenantId}`,
      redirectUri: '/',
      navigateToLoginRequestUrl: false,
      postLogoutRedirectUri: '/auth/login'
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    }
  });
}

function MSALInterceptorConfigFactory(config: AppConfigModel): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(config.msalConfig.api.uri, config.msalConfig.api.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

function MSALGuardConfigFactory(config: AppConfigModel): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...config.msalConfig.api.scopes]
    }
  };
}
